import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import classNames from 'classnames';
import noop from 'lodash-es/noop';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import caret from '../../assets/svg/caretOrange.svg';
import { ElemType, MapClassesToElem } from '../../helpers/styles-helpers';
import { Card } from '../card';

const noBorderClasses = ['noBorders', 'noBordersTop'];

class CollapsibleCard extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    content: PropTypes.node.isRequired,
    contentRight: PropTypes.node,
    dataCy: PropTypes.string,
    initialOpen: PropTypes.bool,
    forceOpen: PropTypes.bool,
    onChange: PropTypes.func,
    type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'noBorders', 'noBordersTop']),
    optionalHeaderClass: PropTypes.string
  };

  static defaultProps = {
    type: 'primary',
    dataCy: 'Collapsible',
    contentRight: null,
    initialOpen: false,
    onChange: noop,
    forceOpen: false,
    optionalHeaderClass: null
  };

  constructor(props) {
    super(props);
    this.state = {
      open: props.initialOpen
    };
  }

  toggle = () =>
    this.setState(
      ({ open }) => ({ open: !open }),
      () => this.props.onChange && this.props.onChange(this.state.open)
    );

  // this function can open a collapsible card "remotely" - added for New Construction checkbox on QuoteForms
  componentDidUpdate(prevProps) {
    if (this.props.forceOpen !== prevProps.forceOpen) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ open: this.props.forceOpen });
    }
  }

  render() {
    const { state, toggle } = this;
    const { open } = state;
    const {
      classes,
      content,
      contentRight,
      children,
      dataCy,
      type,
      initialOpen,
      forceOpen,
      optionalHeaderClass,
      ...props
    } = this.props;
    const noBorder = noBorderClasses.includes(type);

    return (
      <Collapse
        in={open}
        collapsedHeight={noBorder ? '64px' : '70px'}
        className={classNames(classes.collapse, { [classes.noBorders]: noBorder })}
      >
        <Card className={classNames(classes.container, { [classes.containerOpen]: open })} type={type} {...props}>
          <IconButton
            classes={MapClassesToElem(ElemType.IconButton, classes)}
            onClick={toggle}
            data-cy={`${dataCy}-toggle`}
          >
            <img className={open ? classes.icon : classes.iconFold} src={caret} alt={open ? 'fold' : 'unfold'} />
          </IconButton>
          <div className={classNames(classes.header, optionalHeaderClass)}>
            {content && <div className={classes.content}>{content}</div>}
            {contentRight && <div className={classes.contentRight}>{contentRight}</div>}
          </div>
          {open && children}
        </Card>
      </Collapse>
    );
  }
}

export default CollapsibleCard;
